import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['SC', 'Susana C.', 'Buenos Aires', '3 años sin entender por qué la pastilla a veces funcionaba y a veces no. A los 10 días mi papá mejoró notablemente.'], ['RM', 'Rosa M.', 'Córdoba', 'Seguí el sistema con mi marido y en menos de dos semanas los momentos de rigidez se acortaron. Todo con alimentos del super de la esquina.'], ['EP', 'Elena P.', 'Rosario', 'El plan de 7 días fue lo que necesitaba. Por fin tuve una rutina clara para cuidar a mi papá.']] as const;
const extended = [['Susana C.', 'Buenos Aires', '“3 años sin entender por qué algunos días eran buenos y otros un desastre. Al ordenar los horarios de comida, mi papá empezó a tener más momentos activos. Lloré de alivio.”'], ['Rosa M.', 'Córdoba', '“Lo seguí con mi marido y en dos semanas los períodos de rigidez se acortaron. El organizador de rutina fue clave.”'], ['Elena P.', 'Rosario', '“Dejé de improvisar con mi papá. En la primera consulta el neurólogo me dijo que era la primera vez que una familia llegaba con datos tan claros.”'], ['Marcela F.', 'Mendoza', '“Soy enfermera y empecé con escepticismo. Al día 9 los períodos de rigidez de mi mamá se acortaron notablemente.”'], ['Laura G.', 'Santa Fe', '“No sabía que la comida podía interferir tanto con la pastilla. Los momentos ‘ON’ de mi marido duran más.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-168">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-169" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+180', 'familias ya recuperaron el control de la rutina'], ['5', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-170">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-171">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-172">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-173">
                {value}
              </p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-174">
                {label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-175">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-176">
          {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-177">
              <div className="flex items-center gap-3" data-id="element-178">
                <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-179">
                  {initials}
                </div>
                <div data-id="element-180">
                  <h3 className="font-bold" data-id="element-181">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-182">{place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-183">
                <Stars data-id="element-184" />
              </div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-185">
                “{quote}”
              </p>
            </motion.article>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-186">
      <div className="mx-auto max-w-5xl" data-id="element-187">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-188">
          LO QUE DICEN LAS FAMILIAS QUE YA LO TIENEN
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-189">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-190">
              <Stars data-id="element-191" />
              <p className="mt-2 font-bold" data-id="element-192">
                {name}{' '}
                <span className="font-normal text-slate-400" data-id="element-193">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-194">
                {quote}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}